/**
 * SHA-256 digest of a Blob's bytes as 64 lowercase hex characters (Web Crypto).
 * Matches vendor chunked upload init `sha256Hex` contract.
 */
export async function sha256HexFromBlob(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer()
  const digest = await crypto.subtle.digest("SHA-256", buffer)
  const bytes = new Uint8Array(digest)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("")
}
